import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Shared surface for hand-rolled filled content cards (the smaller `rounded-lg`
 * boxes, NOT the `<Card>` primitive which is `rounded-2xl`).
 *
 * Per DESIGN_GUIDELINES §2: a filled card differentiates from the page
 * background by its `bg-card` FILL, not by a border. Borders are reserved for
 * inputs and interactive surfaces. So this is just `rounded-lg bg-card` with no
 * border — compose your own padding (`p-3` / `p-4` / `p-6`) and layout classes
 * at the call site via `cn(FILLED_BOX, "p-4 …")`.
 */
export const FILLED_BOX = 'rounded-lg bg-card';
